<template>
  <CAlert color="white" class="position-absolute TableAlert" :show.sync="payload._message.dismissCountDown">
    <CIcon
      name="approvedFull"
      size="custom-size"
      :height="14"
      :class="`text-${payload._message.status}`"
      class="text-success mr-2"
      color="success"
      viewBox="0 0 32 32"
    />

    {{ payload._message.text }}
  </CAlert>
</template>

<script>
export default {
  name: 'TableAlert',
  //
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },

  computed: {
    dismissCountDown() {
      return this.payload._message.dismissCountDown
    },
  },
}
</script>

<style scoped>
.TableAlert {
  z-index: 99;
}
</style>
